// extracted by mini-css-extract-plugin
export default {"lock-map-section__button-forth":"LockMapSection_lock-map-section__button-forth__1kF-R","lock-map-section__button-back":"LockMapSection_lock-map-section__button-back__2Fpxa"};